import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-character-count',
  templateUrl: './character-count.component.html',
  styleUrls: ['./character-count.component.scss'],
})
export class CharacterCountComponent implements OnInit {
  @Input() control?: UntypedFormControl | null;
  @Input() maxlength?: number | null;

  constructor() {}

  ngOnInit(): void {}
}
